import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { formatISO } from "date-fns";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import { useDates } from "../../../../dates/DatesContext";

export type Params = {
  filters?: ColumnFiltersState;
  search?: string;
  start?: Date;
  end?: Date;
  preStart?: Date;
  preEnd?: Date;
};

export const useGetV4ProductReportTotals = () => {
  const marketPlace = useAppSelector(
    (state: { marketPlace: { marketPlace: string } }) => state.marketPlace.marketPlace,
  );
  const { start, end, preStart, preEnd } = useDates();
  return (params?: Params) => {
    const filters = params?.filters;
    const search = params?.search ? params.search.split(",") : [];

    return queryOptions({
      queryKey: [{ entity: "V4ProductReportTotals", marketPlace, params, dates: { start, end, preStart, preEnd } }],
      queryFn: async () =>
        await apiClient.getV4ProductReportTotals({
          queries: {
            marketplace: marketPlace,
            start_date:
              params?.start ? formatISO(params.start, { representation: "date" }) : start.format("YYYY-MM-DD"),
            end_date: params?.end ? formatISO(params.end, { representation: "date" }) : end.format("YYYY-MM-DD"),
            start_date_previous:
              params?.preStart ? formatISO(params.preStart, { representation: "date" }) : preStart.format("YYYY-MM-DD"),
            end_date_previous:
              params?.preEnd ? formatISO(params.preEnd, { representation: "date" }) : preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(filters),
            search,
          },
        }),
    });
  };
};
